import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntryShellService {

  formTitle : string = '';
  currentModuleName: string = '';
  // headerText : Subject<string> = new Subject();

  // formTitle$ = this.headerText.asObservable();
  constructor(private _router : ActivatedRoute) { 
   }


}
